// test206
(206 && 0);
